import { saveLead } from "./supabase";

const GOOGLE_ADS_PHONE_CONVERSION = "AW-18185897633/2YsjCNO377gcEKGN299D";

export function trackPhoneConversion(source, phone) {
  saveLead({ source, channel: "phone", phone });

  if (typeof window === "undefined" || typeof window.gtag !== "function") return;

  window.gtag("event", "conversion", {
    send_to: GOOGLE_ADS_PHONE_CONVERSION,
    event_callback: () => {},
    event_timeout: 2000,
  });
}
